import {connect} from 'react-redux'
import OutreachBody from '../components/Home/OutreachBody'

function mapStateToProps(state, props) {
  return {
    browser: state.browser
  }
}

export default connect(mapStateToProps)(OutreachBody)


// WEBPACK FOOTER //
// ./src/containers/OutreachBody.js